/**
 * Generates XML for order approval
 * Used by both AdminOrderApproval and PendingOrdersWidget
 */
export const generateOrderXML = (order, accountDebId) => {
  const currentDate = new Date().toISOString().split('T')[0];
  const deliveryAddress = order.delivery_addresses || {};
  const cartItems = order.cart_items || [];

  let xml = `<?xml version="1.0" ?>
<MoPro>
  <Order>
    <OrderDetail>
      <OrderMode>N</OrderMode>
      <OrderNumber>${order.order_number}</OrderNumber>
      <OrderType>E</OrderType>
      <OrderDate>${currentDate}</OrderDate>
      <OrderShipDate>${currentDate}</OrderShipDate>
      <OrderExpiryDate></OrderExpiryDate>
      <OrderInstructions1>${(order.order_instructions || '').slice(0, 100)}</OrderInstructions1>
      <OrderInstructions2>${(order.order_instructions || '').slice(100, 200)}</OrderInstructions2>
      <AccountNumber>${accountDebId}</AccountNumber>
      <EntityCode>MHS</EntityCode>
      <QuoteNumber></QuoteNumber>
      <PriceScheduleCode></PriceScheduleCode>
      <AllowPartialDelivery>${order.allow_partial_delivery ? 'yes' : 'no'}</AllowPartialDelivery>
      <InvoicePerDespatch>no</InvoicePerDespatch>
      <NumberOfLines>${cartItems.length}</NumberOfLines>
      <Comment>${order.order_instructions || ''}</Comment>
      <UserDefined>
        <Field1></Field1>
        <Field2></Field2>
        <Field3></Field3>
        <Field4></Field4>
        <Field5></Field5>
        <Field6></Field6>
      </UserDefined>
    </OrderDetail>
    <Delivery>
      <SiteCode>${deliveryAddress.site_code || ''}</SiteCode>
      <Name>${order.accounts?.company_name || order.accounts?.full_name || ''}</Name>
      <Address1>${deliveryAddress.address_line1 || ''}</Address1>
      <Address2>${deliveryAddress.address_line2 || ''}</Address2>
      <City>${deliveryAddress.city || ''}</City>
      <State>${deliveryAddress.state || ''}</State>
      <PostalCode>${deliveryAddress.postal_code || ''}</PostalCode>
      <DeliveryType>${order.delivery_type || ''}</DeliveryType>
      <SalesPersonID>146</SalesPersonID>
      <Contact>
        <Name>${deliveryAddress.contact_name || ''}</Name>
        <Phone>${deliveryAddress.contact_phone || ''}</Phone>
        <Fax></Fax>
        <Email>${deliveryAddress.contact_email || order.accounts?.email || ''}</Email>
        <Mobile>${deliveryAddress.contact_mobile || ''}</Mobile>
      </Contact>
      <Freight>
        <Carrier>${order.freight_carrier || ''}</Carrier>
        <SendVia>${order.freight_send_via || ''}</SendVia>
        <FreightAccount>${order.freight_account || ''}</FreightAccount>
        <ShippingInstructions>${order.shipping_instructions || ''}</ShippingInstructions>
        <PackingInstructions></PackingInstructions>
      </Freight>
      ${cartItems.map((item, index) => `
      <OrderLine>
        <LineNumber>${index + 1}</LineNumber>
        <Barcode></Barcode>
        <SupplierProductCode>${item.partNumber}</SupplierProductCode>
        <CustomerProductCode></CustomerProductCode>
        <Description>${item.description}</Description>
        <UnitCode></UnitCode>
        <Quantity>${item.quantity}</Quantity>
        <Price>${item.price}</Price>
        <ShipDate></ShipDate>
        <ExpiryDate></ExpiryDate>
        <Comment>${item.comment || ''}</Comment>
        <PackSize>1</PackSize>
        <WarehouseCode>MHS</WarehouseCode>
      </OrderLine>`).join('')}
    </Delivery>
  </Order>
</MoPro>`;

  return xml;
};
